import React from 'react';
import { GAMES } from '../../app/consts';
import { IGameId } from 'types/types';
import { remToPx, formatSeconds, extractMs } from '../../utils/utils';
import { RaceResultProps } from './types';

import SvgIcon from 'components/SvgIcon';
import UserIcon from '../../assets/Icon/user.svg';
import { AvatarPlaceholder } from './RaceResult.style';

const RaceResult: React.FC<RaceResultProps> = ({ race, raceIndex }) => {
  return (
    <div>
      <div className="d-flex flex-column">
        {/* Race number and game name */}
        <div
          className="d-flex flex-row text-uppercase pe-3 pt-1 pb-1"
          style={{ backgroundColor: `#fff` }}
        >
          <div className="oswald-regular text-center">
            Wyścig {raceIndex + 1}
          </div>
          <div className="text-center oswald-light">
             - {GAMES[race?.game.id as IGameId]?.name}
          </div>
        </div>
        {/* Runs container */}
        <div
          className="d-flex flex-column overflow-hidden border-top"
          style={{ gap: `0px` }}
        >
          {race?.runs.map((run, idx) => (
            <React.Fragment key={run.id}>
              {/* Run */}
              <div
                className="d-flex flex-row align-items-center justify-content-between border-bottom ps-2 pe-2 pe-md-3 position-relative overflow-hidden oswald-regular"
                style={{
                  borderLeft: `0.5rem solid ${run.player.extra?.colors?.primary}`,
                  backgroundColor: run.player.extra?.isBest
                    ? `rgba(255, 205, 65, 0.10)`
                    : '',
                  columnGap: `0.5rem`,
                }}
              >
                {/* Player */}
                <div
                  className="text-uppercase d-flex flex-row align-items-center pt-2 pb-2 oswald-regular lh-1"
                  style={{
                    columnGap: `0.5rem`,
                    fontSize: `1.25rem`,
                  }}
                >
                  {/* Photo */}
                  <div
                    className="d-flex justify-content-center align-items-center rounded"
                    style={{
                      backgroundColor: `${run.player.extra?.colors?.primary}`,
                      width: remToPx(3),
                      height: remToPx(3)
                    }}
                  >
                    {run.player.avatar ? (
                      <img
                        src={run.player.avatar || ''}
                        width={remToPx(3)}
                        height={remToPx(3)}
                        className="rounded"
                      />
                    ) : (
                      <AvatarPlaceholder className="d-flex justify-content-center align-items-center rounded">
                        <SvgIcon src={UserIcon} width="2rem" height="2rem" />
                      </AvatarPlaceholder>
                    )}
                  </div>
                  {/* Name */}
                  <div>{run.player.extra?.name}</div>
                </div>

                {/* Result */}
                <div
                  className="text-end"
                  style={{
                    fontWeight: run.player.extra?.isBest ? 700 : 'normal',
                  }}
                >
                  <span className="d-inline-block text-center">
                    {run.player.extra?.isBest && (
                      <span className="ps-2 pe-2">🏆</span>
                    )}
                    {run.status === 'disqualified' && (
                      <span className="ps-2 pe-2">⚠️</span>
                    )}
                    {run.status === 'incomplete' && (
                      <span className="ps-2 pe-2">🌓</span>
                    )}
                  </span>
                  <span className="d-inline-block">
                    {formatSeconds(run.duration)}
                    <span
                      style={{ color: `rgba(0,0,0,0.5)`, fontSize: `0.75em` }}
                    >
                      .{extractMs(run.duration || 0)}
                    </span>
                  </span>
                </div>
                {/* <div className='oswald-regular' style={{ fontWeight: run.player.extra?.isBest ? 700 : 'normal' }}>{run.points}<span style={{fontSize:`0.75em`}}>&nbsp;pkt</span></div> */}
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RaceResult;
